import {useLazyQuery} from '@apollo/client/react';
import {extractGqlData} from '@coolcolduk/ui-apollo-client';
import {Question, QuestionStatus} from '@cp/model';
import {FETCH_QUESTION_FOR_REVIEW} from '../sharedQueries';

export interface FetchQuestionForReviewVariables {
  moduleId: string;
  topics?: string[];
  difficulty?: number;
  status?: QuestionStatus;
  skip?: number;
}

export function useFetchQuestionForReview() {
  const [fetchQuestion, {data, loading, error}] = useLazyQuery<
    {fetchQuestionForReview: Question | null},
    FetchQuestionForReviewVariables
  >(FETCH_QUESTION_FOR_REVIEW, {
    fetchPolicy: 'network-only',
  });

  const fetchQuestionForReview = async (variables: FetchQuestionForReviewVariables) => {
    const result = await fetchQuestion({
      variables,
    });

    return extractGqlData(result).fetchQuestionForReview;
  };

  return {
    fetchQuestionForReview,
    question: data?.fetchQuestionForReview || null,
    loading,
    error,
  };
}
